import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {cardsPreview, tablePreview} from '../../../assets/symbols/symbols/Symbols.css';
import SubscriptionActions from '../subscriptionActions/SubscriptionActions';
import useMobile from '../../../hooks/useMobile';

export const useSubscriptionOperations = () => {
    const {t} = useTranslation('subscriptions');
    const isMobile = useMobile();
    const [isCardView, setIsCardView] = useState(false);
    
    const previewList = {
        table: {icon: cardsPreview, text: t('ticket:cardsPreview')}, 
        cards: {icon: tablePreview, text: t('ticket:tablePreview')}
    };
    const currentPreview = previewList[isCardView ? 'cards' : 'table'];
    
    const operations = {
        children: <SubscriptionActions />,
        icons: !isMobile ? [{
            key: 1,
            icon: currentPreview?.icon,
            tooltipText: currentPreview?.text,
            color: 'transparent',
            onClick: () => {
                setIsCardView(!isCardView);
            }
        }] : undefined
    };
    
    return {operations, isCardView};
};
